import { Container, Size, ShowFor, Button, CrossRegionPersistence } from "@brightagency/headstart-common";
import { shuffle } from "lodash";
import React, { useMemo } from "react";
import { WPPost } from "../../../constants/types";
import { ListingAcf } from "../../../constants/types/acf";
import { useGlobalLinks } from "../../../services/app-state";
import { getAcfPostUrl } from "../../../utils";
import { CarouselControls } from "../../molecules/CarouselControls";
import { ListingCard } from "../../molecules/ListingCard";
import { useCardCarousel } from "../Carousel";
import {
    Wrapper,
    Inner,
    Title,
    Content,
    TextContent,
    Controls,
    SearchAllContainer,    
} from "./styled";

interface Props {
    title: string;
    pagename: string;
    description: string | React.ReactChild;
    items: WPPost<ListingAcf>[];
    displayRegion: boolean;
    compact: boolean;
}

export const ServicesInRegionListings: React.FC<Props> = props => {
    const { Carousel, scrollLeft, scrollRight, canScroll } = useCardCarousel(props.items.length);
    const [, { getGlobalLink }] = useGlobalLinks();
    const regionname = CrossRegionPersistence.getChosenSuburb()?.regionname;
    const compact = props.compact;
    const listings = useMemo(() => shuffle(props.items), [props.items]);

    if (listings.length === 0) {
        return null;
    }

    return (
        <Wrapper className="services-in-region">
            <Container>
                <Inner>
                    <TextContent>
                        <Title>{props.title} {props.displayRegion ? regionname : ''}</Title>
                        <Content>{props.description}</Content>
                    </TextContent>
                    {canScroll && (
                        <ShowFor size={Size.large}>
                            <Controls>
                                <CarouselControls
                                    onLeftClick={scrollLeft}
                                    onRightClick={scrollRight}
                                />
                            </Controls>
                        </ShowFor>
                    )}
                </Inner>
            </Container>
            <Carousel>
                {listings.map(item => (
                    <ListingCard key={item.id} listing={item} compact={compact} />
                ))}
            </Carousel>
            
            {
                (props.pagename == 'all') ? 
                    <Container>
                        <SearchAllContainer>
                            <Button
                                className="search-services"
                                to={getAcfPostUrl(getGlobalLink("local_services_page"))}
                                appearance="secondary"
                            >
                                Search all services
                            </Button>
                        </SearchAllContainer>
                    </Container>
                :
                    ''
            }

        </Wrapper>
    );
};
